import { isSameOrContains } from 'anodum';
import { connectedStore } from '../../store';
import view from '../../view';
import hooks from '../../hooks';
import instance from '../instance';
import getLiveElement from '../accessors/get-live-element';
import preserveTextElement from '../utils/helpers/preserve-text-element';
import getNotDisabledLiveElement from '../utils/helpers/get-not-disabled-live-element.js';
import pickUpIframe from '../utils/helpers/pick-up-iframe';
import pickUpPhoneLink from '../utils/helpers/pick-up-phone-link';
import contenteditableFocus from '../injections/iframe-additives/webkit-workarounds/contenteditable-focus';
import text from '../injections/bindings/text';
import { IMAGE_SELECTOR } from '../constants/image-selector';
import getClosestSelectableElement from '../utils/helpers/get-closest-selectable-element';

const isContentEditable = (element) =>
  element.hasAttribute('contenteditable') && element.getAttribute('contenteditable') === 'true';

const elementTapHandler = (event) => {
  const store = connectedStore.get();
  const state = store.getState();
  const { target } = event.detail;
  const element = pickUpIframe(target) || pickUpPhoneLink(target) || target;

  const currentHoveredElementId = view.selectors.getHoveredElement(state);
  const currentFocusedElementId = view.selectors.getFocusedElement(state);
  const currentSelectedElementId = view.selectors.getSelectedElement(state);
  const currentFocusedElement = getLiveElement(currentFocusedElementId);

  if (
    currentFocusedElementId &&
    isSameOrContains(currentFocusedElement, element) &&
    !element.closest(IMAGE_SELECTOR)
  ) {
    if (!isContentEditable(currentFocusedElement)) {
      contenteditableFocus.resumeByEvent({ target: element });
    }
    return;
  }

  if (currentFocusedElement) {
    preserveTextElement(currentFocusedElement);

    if (element.closest(IMAGE_SELECTOR)) {
      currentFocusedElement.blur();
    }

    hooks.operations.subscribe(
      hooks.availableHooks.ON_AFTER_BLUR_FOCUSED_ELEMENT,
      () => {
        contenteditableFocus.pauseAll(currentFocusedElement.parentNode);
      },
      { once: true }
    );

    store.dispatch(view.actions.blurFocusedElement());
  }

  const { element: touchedElement, id: touchedElementId } = getNotDisabledLiveElement(element);

  if (currentSelectedElementId) {
    const currentSelectedElement = getLiveElement(currentSelectedElementId);

    if (!isSameOrContains(currentSelectedElement, touchedElement)) {
      store.dispatch(view.actions.setSelectedElement(null));
      store.dispatch(view.actions.setHoveredElement(touchedElementId));
      return;
    }
  }

  const currentHoveredElement = getLiveElement(currentHoveredElementId);

  if (currentHoveredElement) {
    const selectableElementForHovered = getClosestSelectableElement(currentHoveredElement);
    const selectableElementForTouched = getClosestSelectableElement(touchedElement);

    if (
      selectableElementForTouched &&
      selectableElementForTouched === selectableElementForHovered
    ) {
      const selectableElementId = instance.driver.referenceMap.getReferenceId(
        selectableElementForTouched
      );

      store.dispatch(view.actions.setSelectedElement(selectableElementId));
    }

    const textElementForHovered = text.getRootTextElement(currentHoveredElement);
    const textElementForTouched = text.getRootTextElement(touchedElement);

    if (textElementForTouched && textElementForTouched === textElementForHovered) {
      contenteditableFocus.resumeByEvent({ target: touchedElement });
    }
  }

  store.dispatch(view.actions.setHoveredElement(touchedElementId));
};

export default elementTapHandler;
